import React, { createContext, useState } from 'react';

export const UserActionContext = createContext();

export const UserActionProvider = ({ children }) => {
	const [userSelectedFiType, setUserSelectedFiType] = useState(null);

	const updateUserSelectedFiType = (fiType) => {
		setUserSelectedFiType(fiType);
	};

	return (
		<UserActionContext.Provider
			value={{
				userSelectedFiType,
				updateUserSelectedFiType,
			}}
		>
			{children}
		</UserActionContext.Provider>
	);
};
